import React from 'react';
import { Route, Routes } from 'react-router';
import { Avgiver } from 'svv-hradm-dinside-brukerhandtering';
import { create } from 'zustand';
import { useAppState } from '../App';
import { useEffectOnce } from '../hooks/useEffectOnce';
import { KnytningBekreftelse } from './knytning/KnytningBekreftelse';
import { KnyttSkilt } from './knytning/KnyttSkilt';
import { Statusoversikt } from './oversikt/Statusoversikt';
import { Skiltbestilling } from './skiltbestilling/Skiltbestilling';
import { Soknad } from './soknad/Soknad';
import { SoknadBekreftelse } from './soknad/SoknadBekreftelse';
import { StatusSoknad } from './status/StatusSoknad';

type InnloggetBrukerState = {
    navn?: string;
    setNavn: (navn: string) => void;
};

export const useInnloggetBruker = create<InnloggetBrukerState>((set) => ({
    navn: undefined,
    setNavn: (navn) => set({ navn }),
}));

const InnloggedeSider: React.FC = () => {
    const { setNavn } = useInnloggetBruker();
    const { setTekniskFeil } = useAppState();
    useEffectOnce(() => {
        const setInnloggetBrukerNavn = async () => {
            try {
                const resultat = await Avgiver.hent();
                setNavn(resultat?.navn);
            } catch {
                setTekniskFeil('Fikk ikke hentet avgiver');
            }
        };
        setInnloggetBrukerNavn();
    });
    return (
        <Routes>
            <Route path="/" element={<Statusoversikt />} />
            <Route path="/statusoversikt" element={<Statusoversikt />} />
            <Route path="/soknad/:tegnkombinasjon?" element={<Soknad />} />
            <Route path="/soknad-bekreftelse" element={<SoknadBekreftelse />} />
            <Route path="/status/:id" element={<StatusSoknad />} />
            <Route
                path="/status/knytt/:tegnkombinasjon"
                element={<KnyttSkilt />}
            />
            <Route
                path="/knytning-bekreftelse"
                element={<KnytningBekreftelse />}
            />
            <Route path="/skiltbestilling/*" element={<Skiltbestilling />} />
        </Routes>
    );
};

export default InnloggedeSider;
